const reviewOpsPositions = new Map()
/** Query-only navigation changes local view/filter state, not the page being read. */
export function adminScrollBehavior(to, from, savedPosition) {
  if (from.path === '/analytics/review-ops' && to.path !== from.path && typeof window !== 'undefined') {
    reviewOpsPositions.set(from.path, { left: window.scrollX || 0, top: window.scrollY || 0 })
  }
  if (savedPosition) return savedPosition
  if (to.path === from.path && to.hash === from.hash) return false
  if (to.path === '/analytics/review-ops' && reviewOpsPositions.has(to.path)) return reviewOpsPositions.get(to.path)
  return { left: 0, top: 0 }
}
